module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', {
    staticClass: "bb mb3 tabnav-container "
  }, [_c('div', {
    staticClass: "tabnav pa3 pt3 pb0 flex mw8 center"
  }, _vm._l((_vm.items), function(item, i) {
    return _c('router-link', {
      key: i,
      staticClass: "item",
      class: item.active ? 'active' : '',
      attrs: {
        "to": item.to
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + " " + _vm._s(_vm.route) + "\n    ")])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5191b84f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./admin/src/components/TabNav.vue
// module id = 252
// module chunks = 0